var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0C26.3889 0 34 7.61116 34 17C34 26.3889 26.3889 34 17 34C7.61116 34 0 26.3889 0 17C0 7.61116 7.61116 0 17 0ZM27.7911 23.5903V10.9556L21.4734 17.2729L27.7911 23.5903ZM7.55864 23.8476H26.4418L20.6706 18.0764L18.471 20.2757C18.3643 20.382 18.2199 20.4417 18.0692 20.4417H15.9309C15.8564 20.4417 15.7825 20.4271 15.7135 20.3986C15.6446 20.3701 15.5819 20.3284 15.5291 20.2757L13.3296 18.0764L7.55837 23.8476H7.55864ZM6.20899 10.9552V23.5906L12.5267 17.2729L6.20899 10.9552ZM26.9879 10.1524H7.01251L16.1662 19.3061H17.8342L26.9879 10.1524Z",
    fill: "#E0AF04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.a2360dc4d32c56033de2628110ce3fac.svg";
export { ForwardRef as ReactComponent };